<template>
    <div id="app" :class="className">
        <CrefoDefaultNavigation />

        <div class="content">
            <router-view :key="route.fullPath" />
        </div>

        <footer style="margin-top: auto !important">
            <CrefoDefaultFooter />
        </footer>

        <FailureDialog
            :headline="dialogHl"
            :message="dialogMsg"
            :close-button-text="getFailureDialog.dialogBtnText"
            :close-button-emit="getFailureDialog.dialogBtnEmit"
            :data-qa="getFailureDialog.dataQa"
            :correlation-id="correlationId"
            :value="getFailureDialog.show"
            @close-action="onFailureButtonClicked"
        />
    </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted } from 'vue'
import CrefoDefaultNavigation from './components/navigation/index'
import CrefoDefaultFooter from './components/footer/index'
import FailureDialog from './components/dialog/failure'
import { useUserStore } from '@/store/module-user'
import { storeToRefs } from 'pinia'
import i18n from '@/i18n'

import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { getCASPreferredLanguageCookie } from '@/helper/cookies.js'

const store = useUserStore()
const { t } = useI18n()
const route = useRoute()

const { getFailureDialog, correlationId, keycloak } = storeToRefs(store)

const dialogMsg = computed(() => {
    const { error, msg } = getFailureDialog.value
    if (Array.isArray(error) && error.length && error[0].errorCode) {
        const i18nKey = `HttpErrorMessages.${error[0].errorCode}`
        return t(i18nKey)
    }

    if (msg !== null && typeof msg !== 'undefined' && msg.length) {
        return msg
    }

    return t('HttpErrorMessages.Default')
})

const dialogHl = computed(() => {
    const value = getFailureDialog.value?.headline
    return value !== null && value?.length
        ? value
        : t('Dialog.Default.Header')
})
const loggedIn = computed(() => !!keycloak.value)
const className = computed(() => {
    const classes = ['logged-' + (loggedIn.value ? 'in' : 'out')]
    return classes.filter(Boolean).join(' ')
})

const keyDown = event => {
    if (
        getFailureDialog.value.show &&
            (event.key === 'Escape' || event.key === 'Enter')
    ) {
        event.key === 'Enter' && event.preventDefault()
        store.resetProfileError()
    }
}

onMounted(() => {
    let clientLanguage = 'de_DE'
    const availableLanguages = [
        'de_DE',
        'de_AT',
        'en_US',
        'fr_FR',
        'fr_LU',
    ]

    const langCode = getCASPreferredLanguageCookie ()
    if (langCode !== null && availableLanguages.includes(langCode)) {
        clientLanguage = langCode
    }
    i18n.global.locale.value = clientLanguage

    window.addEventListener('keydown', keyDown)
    document.body.dataset.ready = 'false'
})

onBeforeUnmount(() => {
    window.removeEventListener('keydown', keyDown)
})

const onFailureButtonClicked = (value, whichBtn) => {
    if (value === 'reload' && whichBtn === 'confirm') {
        location.reload()

        return
    }

    if (
        whichBtn === 'confirm' &&
            (value === 'link' || value === 'external-link') &&
            getFailureDialog.value.dialogBtnEmitLinkTarget?.length
    ) {
        if (value === 'link') {
            location.href = getFailureDialog.value.dialogBtnEmitLinkTarget
        } else {
            window.open(
                getFailureDialog.value.dialogBtnEmitLinkTarget,
                '_blank'
            )
        }
        return
    }

    store.resetProfileError()
}
</script>

<style lang="less">
    @import '@/assets/css/crefo-ui-fonts.min.css';

    html,
    body {
        height: 100%;
    }

    #app {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .content {
        margin-top: 120px;
    }

    .logged-in .content {
        margin-top: 150px;
    }

    .container--relative {
        position: relative;
    }

    .row--boni2019Steps {
        color: #4c4c4c;

        @media only screen and (min-width: 992px) {
            position: absolute;
            top: 109px;
            left: 680px;
            width: 440px;
        }
        @media only screen and (min-width: 1200px) {
            left: 845px;
            width: 460px;
        }

        & > div {
            width: auto;
            flex: none;
        }

        .col--boni2019Steps {
            border: 1px solid #ddd;
            padding: 12px;

            li {
                color: #4c4c4c;
            }

            li.active {
                font-weight: 600;
            }
        }
    }
</style>
